import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {Stock} from '../../models/stock/stock.model';
import {StockState} from '../../state/stock.state';

@Pipe({
  standalone: false,
  name: 'stock'
})
export class StockResolvePipe implements PipeTransform {
  private readonly stocks: Stock[];

  constructor(private store: Store) {
    this.stocks = this.store.selectSnapshot(StockState.stocks);
  }

  transform(value: any): string {
    if (value === null || value === undefined || value === '' || this.stocks?.length === 0) {
      return null;
    }
    const stock = this.stocks.find(c => c.id === value);
    if (stock) {
      return stock.partNumber + ' - ' + stock.partType;
    }
    return null;
  }

}
